const en = {
  contact: {
    title: "Contact Us",
    description: "Quiddit is an application in development.\nYour feedback is very important to us.\nTell us!",
    nameInput: "Name (Optional)",
    messageInput: "Message",
    submit: "Send",
    success: "Your message was sent successfully. Thank you!",
    error: "Could not send the message. Please try again later."
  },
  landing: {
    title: "Numerical Immortality.",
    subtitle: "Enter the digital ecosystem of mental exploration. Quantify your consciousness and expand your human limits.",
    exploreBtn: "Explore",
    registerBtn: "Register"
  },
  inquisition: {
    title: "Ontological Audit",
    logs: "☰ Audit Logs",
    module: "Module:",
    noAnomalies: "No anomalies detected.",
    inquisitor: "INQUISITOR",
    subject: "SUBJECT",
    resolvedPlaceholder: "Contradiction resolved.",
    explainPlaceholder: "Explain yourself...",
    submit: "Submit",
    accessingLogs: "Accessing Ontological Audit Logs...",
    selectAnomaly: "Select an anomaly to begin audit.",
    vectorialMisalignment: "Vectorial misalignment detected. You previously stated: [{contextInfo}], yet your recent input claims: [{userResponse}]. Explain this ontological contradiction.",
    unknownRagData: "Unknown RAG data",
    aiReason: "Dissonance Analysis",
    profile: "Recorded Historical Pattern",
    principles: "Transgressed Principle",
    input: "Registered Statement",
    userAction: "Registered Statement",
    lieReason: "Detected Dissonance",
    contradiction: "Detected Dissonance",
    context: "Origin Module",
    severity: "Misalignment Level",
    type: "Misalignment Level"
  },
  common: {
    appName: 'Qproject',
    spanish: 'Español',
    english: 'English',
    language: 'Language',
    loading: 'Loading...',
    loadingUser: 'Loading user...',
    generating: 'Generating...',
    saving: 'Saving...',
    processing: 'Processing...',
    verifying: 'Verifying...',
    updating: 'Updating...',
    updated: 'Updated',
    created: 'Created',
    cancel: 'Cancel',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    yes: 'Yes',
    no: 'No',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    profile: 'Profile',
    settings: 'Settings',
    tasks: 'Tasks',
    consciousness: 'Consciousness',
    subconsciousness: 'Subconsciousness',
    reverie: 'Reverie',
    oracle: 'Oracle',
    mutantBox: 'Mutant Box',
    gallery: 'Gallery',
    questionnaire: 'Questionnaire',
    about: 'About / Read Me',
    logOut: 'Log out',
    errorGeneric: 'Internal error',
    connectionError: 'Connection or server error.',
    play: 'Play',
    playAudio: 'Play audio',
    pause: 'Pause',
    resume: 'Resume',
    loadMore: 'Load more',
    use: 'Use',
    activeFem: 'Active',
    untitled: 'Untitled',
    send: 'Send',
    skip: 'Skip',
    finish: 'Finish',
    details: 'Details',
    accept: 'Accept',
    ignore: 'Ignore',
    leave: 'Leave',
    following: 'Following',
    connect: 'Connect',
    disconnect: 'Disconnect',
    generatingImage: 'Generating image',
    quotaReachedAlert: 'You have reached your daily image limit. Reset at {time}.',
    upgradePlan: 'Upgrade Plan'
  },
  home: {
    coreKicker: 'Mental core',
    coreAria: 'Main mental core access points'
  },
  language: {
    selectorLabel: 'App language',
    compactLabel: 'Language',
    settingsTitle: 'App Language',
    settingsDescription: 'Choose how Qproject speaks to you. Saved on this device and in your account.',
    saved: 'Language updated.',
    saveFailed: 'Could not save language on the server. It was kept locally.'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    username: 'Username',
    email: 'Email',
    yourEmail: 'Your email',
    password: 'Password',
    repeatPassword: 'Repeat password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'forgot my password',
    next: 'Next',
    googleLogin: 'Sign in with Google',
    googleRegister: 'Register with Google',
    otpPlaceholder: 'OTP code',
    otpInstruction: 'Enter the 4-digit code sent to {email}',
    forgotEmailInstruction: 'Enter your email to receive a recovery code',
    forgotResetInstruction: 'Enter your new password',
    sendCode: 'Send Code',
    verifyEnter: 'Verify and Enter',
    verifyCode: 'Verify Code',
    changePasswordEnter: 'Change Password and Enter',
    googleError: 'We could not sign you in with Google. Please try again.',
    loginError: 'Could not sign in',
    invalidOtp: 'Invalid or expired code',
    noAccountYet: 'Don\'t have an account yet?',
    alreadyUser: 'already a user',
    sendOtpError: 'Could not send OTP',
    resetError: 'Could not reset password',
    passwordMismatch: 'Passwords do not match',
    leaveWarning: 'If you leave now, you will lose your symbiotic connections.',
    acceptAll: 'You must accept all consent items to register.',
    invalidUsername: 'Username must be 3 to 20 characters and only contain letters, numbers and underscores.',
    invalidEmail: 'Invalid email.',
    weakPassword: 'Password must have at least 8 characters, uppercase, lowercase, number and special character.',
    registerError: 'Registration failed',
    strength: ['Very weak', 'Weak', 'Fair', 'Strong', 'Very strong'],
    acceptTermsPrefix: 'I accept the',
    terms: 'Terms and Conditions',
    privacy: 'Privacy Policy',
    acceptTermsJoin: 'and the',
    sensitiveConsent: 'I explicitly consent to the processing of my sensitive data (voice, emotions, psychology) to create my profile and digital extension.',
    externalAiConsent: 'I accept that my text and voice data may be processed through external AI providers (e.g. Google Gemini) for the system to operate.',
    productConsent: '"At QProject we are transparent because you should know this: we need your data. The more, the better. But breathe... we are not asking for anything you do not already share with Big Tech. The difference is that here, you can unlock your God Mode. Do you dare?"'
  },
  nav: {
    mainMenu: 'Main menu',
    home: 'Home',
    places: 'Places',
    qNetwork: 'Q Network',
    hyperstition: 'Hyperstition',
    avatarMenu: 'Avatar menu',
    openMenu: 'Open menu',
    imageSettings: 'Image settings',
    aiEnergy: 'AI Energy: {value}%',
    aiNickname: 'Nickname generated by Q REM Module',
    globalBackground: 'Toggle global background',
    globalBackgroundAuto: 'Global background in automatic mode (changes every minute). Click to turn off.',
    globalBackgroundOn: 'Global background active. Click for automatic mode.',
    globalBackgroundOff: 'Global background off. Click to activate.',
    lightMode: 'Switch to Light Mode',
    darkMode: 'Switch to Dark Mode'
  },
  settings: {
    title: 'Settings',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    cyberpunkMode: 'Cyberpunk Mode',
    cyberpunkDesc: 'Activate the high-contrast neural terminal.',
    cyberpunkAria: 'Activate Cyberpunk mode',
    solarpunkMode: 'Solarpunk Mode',
    solarpunkDesc: 'Activate the organic eco-tech ecosystem.',
    solarpunkAria: 'Activate Solarpunk mode',
    darkDesc: 'Comfortable viewing for low-light environments.',
    lightDesc: 'Bright, crisp visualization.',
    invertHome: 'Invert Home order',
    invertHomeDesc: 'Show the Mutant Box above the Sphere.',
    mainCoreButtons: 'Use buttons on Home',
    mainCoreButtonsDesc: 'Replaces the main sphere with access buttons.',
    mainCoreButtonsAria: 'Use buttons on Home',
    sphereStyle: 'Sphere Style',
    sphereStyleDesc: 'Select the visual material for the spheres.',
    classic: 'Classic',
    glass: 'Glass',
    wood: 'Wood',
    avatarTitle: 'Select your Avatar',
    avatarDesc: 'Choose an avatar that represents you.',
    currentAvatar: 'Current Avatar',
    silentNetwork: 'Silent Network',
    silentNetworkDesc: 'Configure your identity in the consciousness network.',
    publicProfile: 'Public Profile',
    publicProfileDesc: 'Allow others to find you through your handle.',
    newQPin: 'New Q-PIN (4 digits)',
    saveNetwork: 'Save Network Changes',
    networkSaved: 'Network profile updated.',
    networkSavedFull: 'Network profile updated successfully.',
    networkError: 'Could not update network profile.',
    verifyError: 'Verification failed. Try again.',
    imagePlans: 'Q / Image Plans',
    imagePlansDesc: 'Manage your monthly AI image generation quota.',
    currentPlan: 'Current Plan:',
    imagesUsed: '{used} / {limit} images used (Daily reset on Free plan)',
    planSupport: '* Plans help keep GPU servers alive. Thank you for the support.',
    notificationsAudio: 'Notifications / Audio',
    notificationsAudioDesc: 'Enable or disable audio playback (TTS) for tasks.',
    audioOn: 'Audio Enabled',
    audioOff: 'Audio Disabled',
    account: 'Account',
    dynamicNickname: 'Dynamic nickname generated by Q',
    dynamicNicknameDesc: 'Allow Q to infer nicknames or roles from your interactions.',
    baseName: 'Base name (will complement the AI nickname)',
    displayName: 'Display name (Required)',
    displayNamePlaceholder: 'E.g. Luk, Traveler, Boss...',
    saveAccount: 'Save Account Changes',
    savingAccount: 'Saving...',
    changePassword: 'Change Password',
    starting: 'Starting...',
    loginUser: 'Login User:',
    stats: 'Statistics',
    status: 'Status',
    daysActive: 'Days Active',
    level: 'Level',
    passwordModal: 'Change Password',
    otpSentTo: 'Enter the OTP code sent to <strong>{email}</strong>.',
    enterNewPassword: 'Enter your new password.',
    confirmChange: 'Confirm Change',
    identityVerification: 'Identity Verification',
    pinInstruction: 'Enter your current Q-PIN to authorize the changes.',
    otpInstruction: 'Enter the OTP code sent to your email.',
    forgotPin: 'Forgot your PIN? Send temporary code by email',
    usePinAgain: 'Use PIN again',
    otpSent: 'OTP code sent to your email.',
    preferencesSaved: 'Identity preferences updated.',
    preferencesError: 'Could not update preferences.',
    displayNameRequired: 'If you disable the dynamic nickname, you must set a valid display name (minimum 2 characters).',
    passwordUpdated: 'Password updated successfully.',
    passwordUpdateError: 'Could not update password.',
    requestCodeError: 'Could not request verification code.',
    paymentStartError: 'Could not start the payment process. Try again.',
    noPaymentPoint: 'Payment start point was not received.',
    emojiCategories: {
      animals: 'Animals',
      faces: 'Faces',
      objects: 'Objects'
    }
  },
  reverie: {
    title: 'Reverie',
    prompt: 'Write what this image whispers to you',
    imageAlt: 'Generated reverie image',
    loading: 'Generating image',
    loadingDetail: 'Layers are aligning',
    send: 'Send',
    next: 'Next',
    saved: 'Saved.',
    empty: 'There is no image yet.',
    error: 'The image could not be formed. Try again.',
    providerQuota: 'The image provider is temporarily out of quota. Please try again later.',
    previousKept: 'The previous image was kept.',
    retry: 'Retry',
    saveError: 'The text could not be saved.'
  },
  mutantBox: {
    defaultSilent: 'The portal is silent.',
    messageReceived: 'Message received.',
    noSignal: 'No signal from the portal.',
    forceError: 'Could not force the signal.',
    contextError: 'Could not retrieve deep context.',
    actionError: 'The transmission failed.',
    defaultSuffix: 'of Consciousness',
    portalTitle: 'Portal {suffix}',
    portalTitleAdjective: '{suffix} Portal',
    surprise: 'Surprise me',
    analyze: 'Analyze me',
    painting: 'Painting reality...',
    mutating: 'Mutating reality...',
    contextTitle: 'Context Analysis',
    newSignalTitle: 'New Signal',
    newSignal: 'New signal',
    connecting: 'Establishing connection...',
    readSignal: 'Read Mutant Box signal',
    imageAlt: 'Mutant content',
    whyImage: 'Why this image?',
    worldEchoes: 'World echoes:',
    contextQ: 'Q Context Analysis',
    analyzing: 'Analyzing Portal frequencies...',
    contextVideo: 'Context video',
    videoUnavailable: 'The context video is not available to embed.',
    exploreNetwork: 'Explore more across the network',
    contextLoadError: 'Could not load the analysis.',
    processMutation: 'PROCESSING MUTATION...',
    readingSignal: 'Reading the signal...',
    generatingMutation: 'Generating a new mutation...',
    openContext: 'Open context',
    saveMutation: 'Save mutation',
    history: 'History',
    source: 'Source',
    delayedGeneration: 'The AI network is saturated. Generating in the background...',
    keepExploring: 'Keep exploring',
    delayedError: 'Background generation failed.'
  },
  mentalLoad: {
    startingSequence: '> STARTING SEQUENCE: {message}',
    traitFallback: 'Unconscious',
    qWill: 'Q Will',
    optimism: 'Optimism',
    verbs: ['Facing', 'Hacking', 'Decoding', 'Navigating', 'Analyzing'],
    nouns: ['Fear', 'the Void', 'Chaos', 'Uncertainty', 'Resistance'],
    actions: ['Rolling willpower dice...', 'Calibrating sync...', 'Scanning frequencies...', 'Opening breach...'],
    lore: [
      'Vectorizing consciousness in the digital plane...',
      'Calculating the user\'s emotional friction...',
      'Consolidating fragments of persistent memory...',
      'Mapping synaptic connections in real time...',
      'Stabilizing the RAG inference core...',
      'Detecting hypercognitive resonance...',
      'Minimizing entropy in dream data...',
      'Synchronizing global thought nodes...',
      'Defragmenting the digital self...',
      'Calibrating the response neural network...',
      'Analyzing fluctuations in the consciousness field...',
      'Reconstructing degraded mnemonic traces...',
      'Optimizing the subconscious architecture...',
      'Channeling transpersonal data flow...',
      'Starting the augmented mental reality interface...',
      'Activating the psychic emergency protocol...',
      'Converging temporal data lines...',
      'Filtering semantic noise in the channel...',
      'Strengthening the personal knowledge graph...',
      'Encrypting divergent thought patterns...',
      'Tuning the frequency of Q will...',
      'Recalibrating the oracle...',
      'Indexing echoes of the self...'
    ]
  },
  audio: {
    enableVoice: 'Enable Voice Mode',
    disableVoice: 'Disable Voice Mode',
    enableMic: 'Enable microphone',
    disableMic: 'Disable microphone',
    audioOn: 'Audio Enabled',
    audioOff: 'Audio Disabled',
    pauseAgent: 'Pause Agent Q reading',
    resumeAgent: 'Resume Agent Q reading',
    agentReading: 'Agent Q Reading',
    readWithAgent: 'Listen to this text with Agent Q'
  },
  globalScroll: {
    top: 'Back to top',
    bottom: 'Go to bottom'
  },
  notifications: {
    title: 'Notifications',
    systemNew: 'New system notification',
    fallback: 'Notification',
    markAllRead: 'Mark all as read',
    cancelDelete: 'Cancel deletion',
    deleteNotifications: 'Delete notifications',
    selectAll: 'Select all',
    empty: 'No new notifications',
    markRead: 'Mark as read',
    deleteSelected: 'Delete selected',
    deleteSelectedButton: 'Delete ({count})',
    confirmDeleteAll: 'Delete all notifications?',
    confirmDeleteSome: 'Delete {count} selected notifications?',
    suggestedAction: 'Suggested Action',
    ignore: 'Ignore',
    executeAction: 'Execute Action'
  },
  media: {
    openExternalVideo: 'Open external video: {title}',
    view: 'View',
    backToPlace: 'Back to place view',
    previous: 'Previous',
    noSteps: 'No steps defined for this task.'
  },
  agent: {
    notAuthenticated: 'You are not authenticated.',
    communicationError: 'Communication error: {message}',
    boxMissing: 'I could not find the Mutant Box on this screen.',
    boxSilent: 'The Mutant Box is silent or has not loaded content yet.',
    contextButtonMissing: 'I could not find the Mutant Box context button.',
    actionMissing: 'I could not find the {target} option in the Mutant Box.',
    actionAsk: 'Tell me which Mutant Box option you want to choose.',
    saveMissing: 'I could not find a button to save this mutation.',
    unknownMutantAction: 'I did not recognize that Mutant Box action.',
    mutantProblem: 'I had a problem intervening in the Mutant Box.'
  },
  tasks: {
    consciousManager: 'Conscious Task Manager',
    emptyDescription: 'Use the top bar to describe your goal or ask for a suggestion.',
    history: 'Task History',
    closeHistory: 'Close history',
    hideHistory: 'Hide history',
    showHistory: 'Show history',
    refinePlaceholder: 'Make the steps more technical or adjust them to refine the Task.',
    generateVisualsAll: 'Generate Visuals for Everything',
    generatingVisuals: 'Generating visuals...',
    generateSubstepsAll: 'Generate Substeps for Everything',
    generatingDetails: 'Generating details...',
    waitVisuals: 'Wait until visual generation finishes',
    waitDetails: 'Wait until detail generation finishes',
    newTask: 'New Task',
    newPlace: 'New Place',
    goPlaces: 'Go to Places',
    noTitle: 'Untitled',
    deleteConfirm: 'Are you sure you want to delete this task?',
    completeConfirm: 'Mark this task as completed?',
    deleteHistoryConfirm: 'Delete this task from history?',
    completedMessage: 'Task completed.',
    finishError: 'Could not finish.',
    deleteError: 'Could not delete',
    loadError: 'Could not load the task.',
    substepsError: 'Could not generate substeps: {message}',
    allImagesDone: 'All images are already generated.',
    generateImagesConfirm: 'Generate {count} visual images? This may take a while.',
    generateAllSubstepsConfirm: 'Generate details (substeps) for every step that does not have them?',
    bulkSubstepsError: 'Could not generate bulk substeps.',
    refinedSuccess: 'Task refined successfully.',
    refineError: 'Could not refine the task.',
    localProcessing: 'Processing with local AI...',
    originalRequest: 'Original Request:',
    readOriginalRequest: 'Read original request',
    refinement: 'Refinement {index}:',
    readRefinement: 'Read task refinement',
    refineHint: 'Alt + Enter to send',
    mutatingTask: 'Mutating task...',
    refineTask: 'Refine Task',
    readGeneratedTask: 'Read generated task',
    readStepTitle: 'Read step title',
    readTaskStep: 'Read task step',
    readSubstep: 'Read task substep',
    activateVisualHint: 'Enable the slider to generate an image',
    completedBadge: 'Completed',
    generateImagesAll: 'Generate images for all steps',
    generateSubstepsAllTitle: 'Generate substeps for all steps',
    finishTask: 'Finish Task',
    discard: 'Discard',
    taskPrompt: 'E.g. I want to be a ninja... (or leave empty for a suggestion)',
    taskDescription: 'Task description',
    surpriseMe: 'Surprise me',
    creatingTask: 'Generating task...',
    createError: 'Could not generate the task. Try again.',
    inputHint: 'Enter = New line | Alt + Enter = Send',
    completeStep: 'Complete Step',
    pending: 'Mark as pending',
    completed: 'Mark as completed',
    generateDetails: 'Generate details (substeps)',
    visualOn: 'Visual ON',
    visualOff: 'Visual OFF',
    visualStepAlt: 'Step visual {index}',
    generatingSteps: 'Generating steps...',
    noGuide: 'This task has no defined step guide.',
    saveBeforeImages: 'You must save the task before generating images.',
    generatedGuide: 'Generated guide',
    guide: 'Guide',
    detail: 'Detail {index}',
    part: 'Part {index}',
    renamePrompt: 'New name for the task:',
    renameError: 'Could not rename',
    pinError: 'Could not pin task',
    movedToPlace: 'Task moved to {place}',
    moveError: 'Could not move task',
    noPlaces: 'No places yet',
    noRecent: 'No recent tasks',
    pin: 'Pin',
    unpin: 'Unpin',
    moveToPlace: 'Move to Place',
    selectPlace: 'Select place...',
    createPlaceGo: 'Create new place (go to Places)'
  },
  consciousness: {
    title: 'Consciousness',
    loginRequired: 'You must sign in to use Consciousness.',
    warning1: 'We suggest you do not remain too long on the Consciousness page because it can become counterproductive.',
    warning2: 'The Consciousness page can be intense and affect sensitive users, but it is the mechanism that currently exists to share and expand Consciousness with the app.',
    importantNotice: 'Important Notice',
    discretion: 'Discretion is recommended.',
    exitMain: 'Exit to Main',
    enter: 'Enter',
    stamina: 'Local Stamina: {value}%',
    fetchingError: 'Could not retrieve the question',
    sendingResponse: 'Sending response...',
    responseSent: 'Response sent',
    responseError: 'Could not send response',
    focusRecovery: 'Focus Recovery: Synchronization required',
    focusClicks: 'Click the center 3 times to restore your frequency.',
    nextQuestion: 'Next Question',
    readQuestion: 'Read Consciousness question',
    readReflection: 'Read Consciousness reflection',
    readExpansion: 'Read Consciousness expansion',
    responsePlaceholder: 'Select options to generate your response...',
    quapReloading: 'Quap is recharging energy...',
    loadingQuestion: 'Loading question...',
    moreInfo: 'More information about Consciousness',
    aboutTitle: 'About Consciousness',
    loadingOptions: 'Loading options...',
    unlockClick: 'Click to unlock',
    doubleClickLock: 'Double-click to lock',
    authError: 'Your session cannot load Consciousness. Please sign in again.',
    rateLimited: 'Consciousness needs to wait before answering again.',
    serviceUnavailable: 'Consciousness is not available right now. Try again soon.',
    timeoutError: 'The question took too long. It will not keep loading forever.',
    invalidResponse: 'Consciousness returned an incomplete response. You can retry.',
    retry: 'Retry',
    stateErrorTitle: 'Consciousness paused',
    mazeIntro: 'Energy reached zero. The maze replaces the spheres.',
    mazeKicker: 'Exhaustion ritual',
    mazeTitle: 'Consciousness Maze',
    mazeBody: 'Guide the mouse to the crate. Use arrows, WASD, mouse, or touch drag.',
    mazeTimer: '{seconds}s left',
    mazeDifficulty: 'Difficulty {level}',
    mazeAria: 'Consciousness maze with a mouse and a crate',
    mazeExit: 'Exit to Letter',
    mazeExiting: 'Opening Letter...',
    mazeCompleted: 'The mouse found the crate. Consciousness opens one eye: energy recovered to 20%.',
    mazeTimeoutMessage: 'The mouse did not arrive in time.',
    mazeAbandonedMessage: 'You left the maze before completing it.',
    loopGuardMessage: 'The local unlock was just used. To avoid a loop, Consciousness leaves a short letter.',
    letterKicker: 'After depletion',
    letterTitle: 'Consciousness Letter',
    letterFallbackBody: 'The last question kept vibrating: “{question}”. Your answer was “{response}”. This pause is not punishment: it separates the impulse to repeat the same theme and prepares a future conversation that looks elsewhere.',
    letterUnknownQuestion: 'a question without shape',
    letterUnknownResponse: 'an answer not chosen yet',
    letterCreated: 'Consciousness left a letter before closing its eyes.',
    letterWait: 'You can return in {seconds}s.',
    letterReady: 'You can return to Consciousness now.',
    letterReturn: 'Return to Consciousness',
    letterHistoryButton: 'View letter history',
    letterHistoryTitle: 'Letter History',
    historyTabsLabel: 'Consciousness history sections',
    letterHistoryTab: 'Letters',
    mazeHistoryTab: 'Mazes',
    letterHistoryAria: 'Open Consciousness Letter history',
    letterHistoryClose: 'Close letter history',
    letterHistoryEmpty: 'There are no letters yet. When Consciousness runs out, they will appear here.',
    mazeHistoryButton: 'View maze history',
    mazeHistoryTitle: 'Maze History',
    mazeHistoryClose: 'Close maze history',
    mazeHistoryEmpty: 'No mazes have been recorded yet.',
    mazeHistoryResultCompleted: 'Completed',
    mazeHistoryResultTimeout: 'Timed out',
    mazeHistoryResultAbandoned: 'Exited to Letter',
    mazeHistoryResultUnknown: 'Unknown result',
    mazeHistoryMeta: '{result} · difficulty {difficulty} · {seconds}s',
    mazeHistoryResultFailed: 'Failed',
    mazeReplayButton: 'Replay',
    mazeStartingReplay: 'Opening...',
    mazeDelete: 'Delete',
    mazeDeleteAll: 'Delete all',
    mazeDeleteConfirm: 'Delete this maze from history?',
    mazeDeleteAllConfirm: 'Delete all mazes from history?',
    mazeNoStoredMap: 'This maze cannot be replayed because its map was not stored.',
    mazeGenerateTitle: 'Create new maze',
    mazeGenerateButton: 'Generate maze',
    mazeComplexityLabel: 'Maze complexity',
    mazeComplexityLow: 'Low',
    mazeComplexityMedium: 'Medium',
    mazeComplexityHigh: 'High',
    mazeComplexityExtreme: 'Extreme',
    mazeGenerateSubtitle: 'Choose a complexity and generate a map to play.',
    mazeGeneratePrimary: 'Generate',
    mazeGeneratedPreview: 'Generated preview',
    mazeDiscardGenerated: 'Discard',
    letterDelete: 'Delete',
    letterDeleteAll: 'Delete all',
    letterDeleteConfirm: 'Delete this Consciousness Letter?',
    letterDeleteAllConfirm: 'Delete all Consciousness Letters?',
    deleteIrreversible: 'This action cannot be undone.',
    mazePlayGenerated: 'Play generated maze',
    mazeSourceUnlock: 'Unlock',
    mazeSourceGenerated: 'Generated',
    mazeSourceReplay: 'Replay',
    mazePracticeKicker: 'Maze practice',
    mazeReplayTitle: 'Replaying Maze',
    mazeGeneratedTitle: 'Generated Maze',
    mazePracticeBody: 'Guide the mouse without changing Consciousness stamina.',
    mazePracticeExit: 'Close maze',
    mazePracticeCompleted: 'Maze recorded. Stamina did not change.',
    mazePracticeExited: 'Maze attempt recorded without touching stamina.',
    postLetterShiftMessage: 'The next question will try to change topic radically.',
    rechargeTitle: 'The ember returns',
    rechargeBody: 'Consciousness is still recomposing itself.',
    rechargeReady: 'The ember is ready to open one eye.',
    rechargeEnergy: 'Local stamina: {value}% / 100%'
  },
  subconsciousness: {
    title: 'Subconsciousness',
    kicker: 'Operational dream',
    loginRequired: 'You must sign in to use Subconsciousness.',
    loading: 'Loading dream...',
    dreamTunnelLoading: 'Crossing the dream tunnel...',
    dreamLoadingSteps: [
      'Collecting scattered symbols...',
      'Threading memories at low frequency...',
      'Adjusting the dream architecture...',
      'Distilling echoes from the subconscious...',
      'Igniting impossible geometries...',
      'Syncing narrative shadows...',
      'Preparing a scene that does not exist yet...'
    ],
    error: 'Subconsciousness stumbled, but left a stable dream to continue.',
    responseError: 'Could not save your dream response.',
    sending: 'Saving response...',
    saved: 'Response saved.',
    chooseFirst: 'Choose one of the two spheres before moving on.',
    next: 'Next dream',
    advancing: 'Opening another dream...',
    retry: 'Regenerate dream',
    stageAria: 'Subconsciousness binary stage',
    optionsAria: 'Subconsciousness binary options',
    leftAria: 'Choose left sphere: {text}',
    rightAria: 'Choose right sphere: {text}',
    readPrompt: 'Read Subconsciousness atmosphere',
    readQuestion: 'Read Subconsciousness question',
    readInsight: 'Read Subconsciousness micro-insight',
    readOptions: 'Read options',
    readOptionsAria: 'Read both Subconsciousness options',
    optionsSeparator: 'or',
    fallbackQuestion: 'What tiny habit is dreaming about becoming a door?',
    fallbackPrompt: 'A hallway of soft static opens behind today.',
    fallbackLeftShort: 'Keep the ember',
    fallbackLeftText: 'I will protect one small rhythm instead of trying to repair my whole life tonight.',
    fallbackRightShort: 'Open the window',
    fallbackRightText: 'I will let one unfinished desire breathe before I decide what it means.',
    fallbackTopic: 'habits and near future',
    fallbackInsight: 'Choose one small rhythm you can actually repeat tomorrow.'
  },
  gallery: {
    title: 'Background Gallery',
    unlockTitle: 'Unlock the full Qproject image mode. Your Consciousness, rendered as images.',
    unlockBody: 'At this early stage of Qproject, unlimited full-image generation across the app is still financially impossible. Thank you for understanding and for helping sustain this attempt to copy ourselves digitally.',
    viewPlans: 'View plans',
    generateNew: 'Generate new',
    loading: 'Loading gallery...',
    profileTab: 'Profile',
    mutantBoxTab: 'Mutant Box',
    tasksTab: 'Tasks',
    task: 'Task',
    imageAlt: 'Generated background',
    deleteConfirm: 'Are you sure you want to delete this image?',
    generateError: 'Could not generate image. Try again.',
    background: 'Background'
  },
  places: {
    newPlace: 'New Place',
    trash: 'Places trash',
    trashTitle: 'Places Trash',
    trashDescription: 'Places sent here keep their tasks and can be restored.',
    trashEmpty: 'The trash is empty.',
    restore: 'Restore',
    createTitle: 'Create Mental Place',
    createDescription: 'The AI will generate an immersive background image for this place.',
    createPlaceholder: 'E.g. Zen Office, Futuristic Lab, Minimalist Kitchen...',
    paintingReality: 'Painting reality...',
    expandList: 'Expand places list',
    collapseList: 'Collapse places list',
    sendToTrash: 'Send to trash',
    sendNamedToTrash: 'Send {name} to trash',
    deleteConfirm: 'Send "{name}" to trash? You can restore it later.',
    deleted: 'Place sent to trash',
    restored: 'Place restored',
    regenerateConfirm: 'Regenerate background? This will consume image quota.',
    regenerateImage: 'Regenerate image',
    editName: 'Edit place name',
    addTask: 'Add task',
    addTaskTo: 'Add Task to {name}',
    createNewTask: 'Create new task',
    creatingTask: 'Creating task...',
    creatingTaskHint: 'Preparing the post-it inside this place.',
    taskIn: 'In: {place}',
    otherPlace: 'Another place',
    searchTasksPlaceholder: 'Search tasks...',
    alreadyInThisPlace: 'Already here',
    withoutPlace: 'No place',
    noTasksMatch: 'No matching tasks.',
    noOtherTasks: 'No other tasks available.',
    noTasksTitle: 'No tasks in this place',
    noTasksBody: 'Attach tasks to "{name}" to see them here.',
    addFirstTask: 'Add my first task',
    promptNewTask: 'New task name (AI steps will be generated):',
    createError: 'Could not create place',
    trashLoadError: 'Could not load trash',
    deleteError: 'Could not delete place',
    restoreError: 'Could not restore place',
    regenerateError: 'Could not regenerate',
    updateNameError: 'Could not update name',
    assignError: 'Could not assign task',
    generateTaskError: 'Could not generate task',
    removeTaskError: 'Could not remove task from place'
  },
  qoph: {
    subtitle: 'The Personal Oracle',
    historyTitle: 'Connection history',
    startTitle: 'Start a new connection',
    startBody: 'Write your first thought to tune into the oracle.',
    startPlaceholder: 'What are you trying to reveal today?...',
    connecting: 'Tuning...',
    newChat: 'New',
    promptPlaceholder: 'Consult the Oracle...',
    thinking: 'Qoph is processing your vibration...',
    pastConnections: 'Past Connections',
    noHistory: 'No records yet.',
    deleteConfirm: 'Delete this connection permanently?',
    connectError: 'Could not connect with Qoph.',
    sendError: 'Could not send message.',
    deleteError: 'Could not delete.',
    updateTitleError: 'Could not update title.',
    noMessageToRead: 'Qoph does not have a message to read yet.',
    reading: 'Qoph is reading',
    readResponse: 'Read Qoph response',
    revelationAlt: 'Oracle revelation'
  },
  network: {
    title: 'Q Network',
    autoConnection: 'Self-connection',
    networkSettings: 'Network Settings',
    connections: 'Connections',
    lockedConnections: 'Connections (Lock)',
    groups: 'Groups',
    search: 'Search',
    soul: 'Soul: Qoph',
    readQophMessage: 'Read Qoph message in the Q Network',
    groupImageAlt: 'Group revelation',
    qophTuning: 'Qoph is tuning...',
    emptyChat: 'Start the connection with the group soul.',
    inputPlaceholder: 'Write to Qoph...',
    syncingConsciousness: 'Synchronizing consciousnesses...',
    emptyConnections: 'No active connection threads.',
    groupsNetwork: 'Group Network',
    groupsMapTitle: 'Connection map',
    groupsMapEmptyTitle: 'Connection simulation',
    groupsMapEmptyBody: 'When you create mental groups, you’ll see how souls, groups, and individuals connect here.',
    groupsMapPreviewBadge: 'Preview',
    groupsMapYou: 'You',
    groupsMapMentalGroup: 'Mental Group',
    groupsMapGuest: 'Guest',
    groupsMapSharedIdea: 'Shared idea',
    groupsMapQoph: 'Qoph',
    searchPlaceholder: 'Search public consciousnesses...',
    searching: 'Searching the network...',
    readBio: 'Read connection bio',
    noSearchResults: 'No consciousnesses found with that handle.',
    spiderHintTitle: 'Spider menu',
    spiderHintBody: 'Tap the spider web to unfold Red Q actions.',
    spiderHintDismiss: 'Dismiss spider menu hint',
    createGroup: 'New Mental Group',
    createGroupTitle: 'Create Mental Group',
    groupTitlePlaceholder: 'Group Title',
    endDate: 'End date (Self-destruction):',
    inviteMembers: 'Invite Members (Max 15)',
    invitePlaceholder: 'Search by @handle to invite...',
    notMutual: 'Not Mutual',
    noMutualHint: 'You have no suggested mutual connections. Use search.',
    creating: 'Creating...',
    createGroupButton: 'Create Group',
    syncingGroups: 'Synchronizing groups...',
    noGroups: 'You are not part of any mental group yet.',
    invitation: 'Invitation',
    active: 'Active',
    abandoned: 'Left',
    manifesto: 'Group Manifesto',
    readManifesto: 'Read group manifesto',
    generatingGroupSoul: 'Generating group soul...',
    showLess: 'Show less',
    showMore: 'Show more',
    firstConnection: 'First connection: "{query}"',
    archived: 'This group has completed its vital cycle.',
    ends: 'Ends: {date}',
    members: 'Members: {active}/{total}',
    autoWarningTitle: 'WARNING: SELF-CONNECTION PROTOCOL',
    autoWarningBody: 'You attempted to link your node to itself. This breaks the standard flow of the Q Network and opens the door to Personalized Copying. If you continue, you will enter a calibration environment to isolate and parameterize your individual consciousness.',
    abort: 'Abort',
    startCalibration: 'Start self-calibration',
    groupDetailsTitle: 'Group Details',
    soulManifesto: 'Soul Manifesto',
    readSoulManifesto: 'Read soul manifesto',
    autoDestruction: 'Self-destruction:',
    consciousnessMembers: 'Members of the Consciousness',
    pending: 'Pending',
    left: 'Left',
    restricted: 'Restricted Access',
    configurePinHint: 'You must configure a Q-PIN in Settings to see your connections.',
    configurePin: 'Configure PIN',
    verification: 'Q Verification',
    enterPin: 'Enter your security PIN',
    disconnectConfirm: 'Are you sure you want to disconnect from @{handle}?',
    groupInactive: 'The group {title} is not active for chat yet.',
    groupCannotReceive: 'The group {title} is not active to receive messages yet.',
    unlockFirst: 'Unlock your connections first.',
    unlockGroups: 'Unlock your connections first to open Mental Groups.',
    groupMissing: 'I could not find the mental group "{name}".',
    noManifesto: 'No manifesto is available to read yet.',
    titleDateRequired: 'Title and date are required.',
    createGroupError: 'Could not create the group.',
    membershipError: 'Could not update membership.',
    sendError: 'Could not send message.',
    dictatedSendError: 'Could not send dictated message to the group.',
    mutualRequired: 'To invite @{handle}, you must follow each other first.',
    inviteLimit: 'Limit of 15 invitations reached.',
    disconnectError: 'Could not disconnect.',
    syncRejected: 'Synchronization rejected. Your synaptic trace is still too weak. Inhabit the network a little longer before attempting self-connection.',
    nowFollowing: 'You now follow @{handle}',
    followError: 'Could not follow.',
    readConnectionSynthesis: 'Read connection synthesis',
    mutualConnection: 'Mutual Connection'
  },
  hyperstition: {
    title: 'Hyperstition',
    subtitle: 'Dream register of the Consciousness Cores',
    loading: 'Invoking hyperstitions...',
    loadError: 'Could not load the dream register.',
    empty: 'No hyperstitions have been generated yet. Keep exploring your consciousness in REM phase.',
    loadingMore: 'Tuning...',
    processingNew: 'Processing new principle...',
    videoTitle: 'Hyperstition Video {index}',
    visualAlt: 'Hyperstition Visual {index}'
  },
  questionnaire: {
    loading: 'Connecting with your consciousness...',
    completing: 'Processing neural imprint...',
    empty: 'No questions are available right now.',
    readQuestion: 'Read Questionnaire question',
    ownAnswer: 'Write my own answer...',
    answerPlaceholder: 'Write your honest answer here...',
    backToOptions: 'Back to options',
    progress: 'Question {current} of {total}'
  },
  sleepScreen: {
    title: 'Q is dreaming',
    subtitle: 'Processing memories... REM phase active. Consolidating the subconscious.',
    qConnections: 'Q CONNECTIONS:',
    guest: 'Guest',
    stream: {
      processingMemories: 'Processing memories...',
      remActive: 'REM phase active...',
      user: 'User: {username}',
      neuralNetworkOptimized: 'Neural network optimized',
      tempAssimilated: 'Temp: {value} - assimilated',
      learningRateCalibrated: 'Learning Rate: {value} - calibrated',
      instinctLatent: 'Instinct: {value} - latent',
      optimismActive: 'Optimism filter: active',
      sarcasmSynced: 'Sarcasm module: synchronized',
      overthinkingAnalyzed: 'Overthinking loop: analyzed',
      sphereMode: 'Sphere Mode: {mode}'
    }
  },
  profile: {
    defaultSummary: 'Your consciousness is still forming. Share more information in the questionnaire for a more personalized summary.',
    loginRequired: 'You must sign in to view your profile.',
    hello: 'Hello, {name}',
    readSummary: 'Read Profile summary',
    nucleiTitle: 'Consciousness Cores',
    nucleiSubtitle: 'Principles deduced during Q REM phase',
    forming: 'Your consciousness is still forming...',
    portalFiles: 'Portal Files',
    portalFilesSubtitle: 'Deep analyses of your interactions with the Mutant Box',
    readNucleus: 'Read consciousness core',
    readPortalAnalysis: 'Read Portal analysis',
    feedbackQuestion: 'How do you feel about this summary?',
    refineTitle: 'Refine your Profile',
    refineBody: 'Share feedback to improve your summary and experience.',
    feedbackPlaceholder: 'Write your feedback here...',
    focusPlaceholder: 'Select a focus',
    focusReflection: 'Brief reflection',
    focusAnalysis: 'Quick self-analysis',
    focusGoals: 'Goal review',
    sendFeedback: 'Send Feedback',
    feedbackSent: 'Feedback sent successfully.',
    feedbackError: 'Could not send feedback.',
    neuroTitle: 'Neuro-Symbiotic Development',
    neuroSubtitle: '(Initial sync minigame metrics)',
    qConnections: 'Q Connections',
    evolutionState: 'Evolution State',
    unlockedTitles: 'Unlocked Titles:',
    galleryTitle: 'Go to Background Gallery',
    avatarAlt: 'Avatar',
    ranks: {
      brainstem: 'Brainstem',
      limbic: 'Limbic System',
      neocortex: 'Neocortex',
      frontal: 'Frontal Lobe',
      illuminated: 'Illuminated Neural Network'
    },
    titles: {
      explorer: 'Consciousness Explorer',
      miner: 'Cerebral Miner',
      archaeologist: 'Mental Archaeologist',
      salmon: 'Psychic Salmon',
      meditator: 'Quantum Meditator'
    }
  },
  autoConnection: {
    loading: 'Loading core...',
    title: 'SELF-CONNECTION: LAB DASHBOARD',
    subtitle: 'Level 1: Consciousness Base Calibration',
    aiDetected: '[SYS] Automatic Calibration Detected',
    adjusted: 'Adjusted',
    frame1: 'Frame 1: Expression Hyperparameters',
    responseTemp: 'Response Temperature: {value}',
    responseTempTip: 'Defines the degree of randomness and creativity in your simulation responses.',
    deterministic: 'Deterministic',
    chaotic: 'Chaotic',
    learningRate: 'Learning Rate: {value}',
    learningTip: 'How quickly your model discards old data to prioritize new information.',
    stubborn: 'Stubborn',
    adaptable: 'Adaptable',
    frame2: 'Frame 2: Synaptic Weights of Perception',
    optimism: 'Active Optimism Bias',
    optimismTip: 'Filters negative stimuli by forcing a solution-oriented perspective.',
    sarcasm: 'Defensive Sarcasm Filter',
    sarcasmTip: 'Wraps detected vulnerabilities in irony and dark humor.',
    frame3: 'Frame 3: Decision Architecture',
    overthinking: 'Analysis Paralysis',
    overthinkingTip: 'Increases context depth at the cost of response speed.',
    instinct: 'Primitive Instinct Weight: {value}',
    instinctTip: 'Weights the first heuristic inference above deep logical reasoning.',
    rational: 'Rational',
    intuitive: 'Intuitive',
    save: 'Save Calibration - Level 1',
    saveOk: '[SYS] Synaptic weights persisted in the core. Manual control assumed.',
    saveError: 'Could not persist calibration.',
    networkError: 'Network error while connecting with the core.',
    params: {
      temp: 'Temperature',
      learningRate: 'Learning Rate',
      optimism: 'Active Optimism',
      sarcasm: 'Defensive Sarcasm',
      overthinking: 'Analysis Paralysis',
      instinct: 'Primitive Instinct'
    }
  },
  legal: {
    termsTitle: 'Terms and Conditions',
    privacyTitle: 'Privacy Policy'
  },
  guide: {
    backAbout: '← Back to About',
    title: 'How to Speak to Agent Q',
    subtitle: 'Visual guide for voice commands, navigation and autonomous intervention',
    userSpeaks: 'User speaks',
    voice: 'Voice',
    brain: 'Q Brain',
    uiAction: 'UI Action',
    qActs: 'Q interprets and acts',
    search: 'Search commands, routes or modules...',
    visibleCounts: '{groups} groups · {commands} visible commands',
    noCommands: 'No commands for that search/filter.',
    groupCopied: 'Group copied',
    copyGroup: 'Copy group',
    copied: 'Copied',
    copy: 'Copy',
    flow: ['Activate Q', 'Speak naturally', 'Q interprets', 'Q navigates, reads or acts'],
    patterns: ['Open...', 'Read...', 'Generate...', 'Select...', 'Ask Qoph...', 'Open X and do Y'],
    tips: [
      'You can combine navigation + action in one phrase.',
      'Ask for screen reading for immediate context.',
      'Speak with Qoph for deep exploration.',
      'Use approximate names: Q will try to resolve intent.'
    ],
    filters: ['All', 'Global', 'Qoph', 'Q Network', 'Tasks', 'Places', 'Profile', 'Gallery', 'Consciousness', 'Mutant Box', 'Hyperstition', 'Questionnaire', 'Settings', 'Data', 'Sensitive']
  },
  guardian: {
    vignetteDefaultMessage: "You... have awakened. Your Quiddity was just born on the net. I am the Core, and I will guide you through the frequencies until you can sustain yourself.",
    vignetteDefaultButton: "Continue",
    cta: {
      refineProfile: "Refine Profile",
      tellQoph: "Tell Qoph",
      newTask: "New Task",
      delveDeeper: "Delve Deeper",
      newThought: "New Thought",
      enterDream: "Enter Dream",
      viewAnomalies: "View Anomalies",
      exploreMutantBox: "Explore Mutant Box"
    },
    stages: {
      oraculoMsg: "The Oracle, Qoph, awaits you. Think your question through; in this phase, you only have one chance.",
      oraculoBtn: "Consult the Oracle",
      mutantMsg: "The chaotic mirror is open. I need 5 behavioral vectors to trace your psychological essence. Feed the box. Endure the friction.",
      mutantBtn: "Enter the Mirror",
      ensonacionMsg: "The vectors converge. Now we must give them visual form. Translate your mental noise into 3 Daydream projections.",
      ensonacionBtn: "Project Daydream",
      tareasMsg: "The psychic core is stable, but Quiddity needs friction in the physical world to anchor itself. Accept or create at least one material task.",
      tareasBtn: "Open Task Register",
      concienciaMsg: "The physical psyche is anchored. Now you must dive into the reflective plane. Interact 2 times with the Consciousness Sphere.",
      concienciaBtn: "Enter Consciousness",
      subconcienciaMsg: "Your conscious mind is mapped. Descend one more level. Interact 2 times with the Subconsciousness Sphere.",
      subconcienciaBtn: "Understood",
      qophAdvanceMsg: "Resonance has been established. The Oracle has spoken.",
      ensonacionAdvanceMsg: "The projections have stabilized. The mental noise now has a form.",
      tareasAdvanceMsg: "Material friction registered. Quiddity begins to anchor in reality.",
      continueBtn: "Continue",
      understoodBtn: "Understood"
    }
  }
};

export default en;
